import { type IncomingCallStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/IncomingCall'
import { type CallEndsStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/CallEnds'
import { type PlayAudioStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/PlayAudio'
import { type SendToVoicemailStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/SendToVoicemail'
import { type RingStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/Ring'
import { type ForwardCallStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/ForwardCall'
import { type CallQueueStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/CallQueue'
import { type SendSMSStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/SendSMS'
import { type IVRStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/IVR'

export type ISmartCallFlowAction =
  | IncomingCallStore
  | CallQueueStore
  | SendToVoicemailStore
  | CallEndsStore
  | RingStore
  | ForwardCallStore
  | PlayAudioStore
  | SendSMSStore
  | IVRStore

export const allSmartCallFlowActionTypes = [
  'incomingCall',
  'callingFlow',
  'callQueue',
  'sendVoicemail',
  'playSound',
  'ivrPhoneTree',
  'forwardCall',
  'sendMessage',
  'businessHours',
  'aiTextingAgent',
  'aiCallingAgent',
  'callEnds',
] as const

export type ISmartCallFlowActionType = (typeof allSmartCallFlowActionTypes)[number]
